import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AlertNotificationProps } from "../Components/reusableComponents/AlertNotification/types";
import { RolesData } from "../config";
import { themeObject } from "../Theme/CustomTheme";

import {
    GetAllRoles,
    getAllUsers,
    getAllUsersByDealerID,
    GetBidByUserIdData,
    GetBidsData,
    GetChatId,
    GetDashboardData,
    GetDealer,
    GetInventory,
    GetProducts,
    GetRoleDetailsByRoleId,
    GetViewList,
    ProdcutFilter
} from "./asyncThunk";
import { initialState } from "./InitialState";
import { BreakPointsProps, dealersTab, InitialState } from "./types";

export const MainProvider = createSlice({
    name: "state",
    initialState,
    reducers: {
        updateUser: (state: InitialState, action: PayloadAction<any>) => {
            state.user = action.payload;
        },
        updateBidsDetails: (state: InitialState, action: PayloadAction<any>) => {
            state.bidsCarDetails = action.payload;
        },
        updateLoader: (state: InitialState, action: PayloadAction<any>) => {
            state.initalApiStatus = { ...action.payload };
        },
        showAlert: (state: InitialState, action: PayloadAction<AlertNotificationProps>) => {
            state.alertNotification = {
                ...state?.alertNotification,
                ...action?.payload
            };
        },
        handleModel: (state: InitialState, action: PayloadAction<any>) => {
            state.modal = { ...state.modal, ...action.payload };
        },
        handleBreakPoints: (state: InitialState, action: PayloadAction<BreakPointsProps>) => {
            state.breakPoints = action.payload;
        },
        switchTheme: (state: InitialState) => {
            state.theme.mode = state.theme.mode === "dark" ? "light" : "dark";
        },
        updateTheme: (state: InitialState, action: PayloadAction<themeObject>) => {
            state.theme = { ...state.theme, ...action.payload };
        },
        handleChatOpen: (state: any, action: PayloadAction<any>) => {
            state.chatmodel = action.payload;
        },
        getDealerByID: (state: InitialState, action: PayloadAction<any>) => {
            state.dealerByID = action.payload;
        },
        handleDealers: (state: InitialState, action: PayloadAction<any>) => {
            state.dealers = action.payload;
        },
        handleUpdateDealer: (state: InitialState, action: PayloadAction<any>) => {
            state.updatedDealer = action.payload;
        },
        showDealersTab: (state: InitialState, action: PayloadAction<dealersTab>) => {
            state.dealersTab = {
                ...state?.dealersTab,
                ...action?.payload
            };
        },
        handleErrorState: (state: InitialState, action: PayloadAction<any>) => {
            state.errorState = action.payload;
        },
        handleTabs: (state: InitialState, action: PayloadAction<any>) => {
            state.SwitchTab = action.payload;
        },
        handleUpdateDealerUsers: (state: InitialState, action: PayloadAction<any>) => {
            state.updateDealerUser = action.payload;
        },
        handleChatReply: (state: InitialState, action: PayloadAction<any>) => {
            state.ChatData = action.payload;
        },
        handleUpdateInventory: (state: InitialState, action: PayloadAction<any>) => {
            state.updateInventoryFilteredData = action.payload;
        },
        updateInventory: (state: InitialState, action: PayloadAction<any>) => {
            state.editInventory = action.payload;
        },
        handleProductDetail: (state: InitialState, action: PayloadAction<any>) => {
            state.productDetail = action.payload;
        },
        updateInventoryList: (state: InitialState, action: PayloadAction<any>) => {
            state.InventoryList = action.payload;
        },
        handleFiltersInventory: (state: InitialState, action: PayloadAction<any>) => {
            state.FiltersData = action.payload;
        },
        handleClearAllInventory: (state: InitialState, action: PayloadAction<any>) => {
            state.ClearAll = action.payload;
        },
        handleDealerState: (state: InitialState, action: PayloadAction<any>) => {
            state.dealerState = action.payload;
        },
        handleRoadDealerAdmin: (state: InitialState, action: PayloadAction<any>) => {
            state.RoadDealerAdmins = action.payload;
        },
        handleUpdateRoadDealerAdmin: (state: InitialState, action: PayloadAction<any>) => {
            state.updateRoadDealerAdmin = action.payload;
        },
        handleProductImges: (state: InitialState, action: PayloadAction<any>) => {
            state.productImages = action.payload;
        },
        handleHomePageNavigation: (state: InitialState, action: PayloadAction<any>) => {
            state.HomePageNavigation = action.payload;
        },
        handleDealerAdmin: (state: InitialState, action: PayloadAction<any>) => {
            state.dealerAdminData = action.payload;
        },
        handleChatRoomData: (state: InitialState, action: PayloadAction<any>) => {
            state.chatRoom = action.payload;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(GetAllRoles.pending, (state: InitialState) => {
                state.loaderState = { loading: true };
            })
            .addCase(GetAllRoles.rejected, (state: InitialState) => {
                state.loaderState = { loading: false };
            })
            .addCase(GetAllRoles.fulfilled, (state: InitialState, action: PayloadAction<any>) => {
                state.loaderState = { loading: false };
                state.Roles = action?.payload?.data?.map((e: any) => {
                    return { value: e.Role_Id, label: e.Role };
                });
            })
            .addCase(GetDealer.pending, (state: InitialState) => {
                state.dealerLoader = { loading: true };
            })
            .addCase(GetDealer.rejected, (state: InitialState) => {
                state.dealerLoader = { loading: false };
            })
            .addCase(GetDealer.fulfilled, (state: InitialState, action: PayloadAction<any>) => {
                state.dealerLoader = { loading: false };
                state.dealers = action?.payload?.data;
            })
            .addCase(GetChatId.fulfilled, (state: InitialState, action: PayloadAction<any>) => {
                state.loaderState = { loading: false };
                state.chatNotify = action?.payload?.data?.data;
            })
            .addCase(GetInventory.pending, (state: InitialState) => {
                state.loaderState = { loading: false };
                state.inventoryLoader = { loading: true };
            })
            .addCase(GetInventory.rejected, (state: InitialState) => {
                state.loaderState = { loading: false };
                state.inventoryLoader = { loading: false };
            })
            .addCase(GetInventory.fulfilled, (state: InitialState, action: PayloadAction<any>) => {
                state.loaderState = { loading: false };
                state.inventoryLoader = { loading: false };
                state.InventoryList = action?.payload?.data;
                state.BidManagement = action?.payload?.data?.filter((e: any) => e.Bids);
            })
            .addCase(GetProducts.pending, (state: InitialState) => {
                state.productLoader = { loading: true };
            })
            .addCase(GetProducts.rejected, (state: InitialState) => {
                state.productLoader = { loading: false };
            })
            .addCase(GetProducts.fulfilled, (state: InitialState, action: PayloadAction<any>) => {
                state.productLoader = { loading: false };
                state.ProductListData = action?.payload?.data;
            })
            .addCase(GetBidsData.pending, (state: InitialState) => {
                state.loaderState = { loading: false };
            })
            .addCase(GetBidsData.rejected, (state: InitialState) => {
                state.loaderState = { loading: false };
            })
            .addCase(GetBidsData.fulfilled, (state: InitialState, action: PayloadAction<any>) => {
                state.loaderState = { loading: false };
                state.TotalBids = action?.payload?.data;
            })
            .addCase(getAllUsers.pending, (state: InitialState) => {
                state.userLoader = { loading: true };
            })
            .addCase(getAllUsers.rejected, (state: InitialState) => {
                state.userLoader = { loading: false };
            })
            .addCase(getAllUsers.fulfilled, (state: InitialState, action: PayloadAction<any>) => {
                state.userLoader = { loading: false };
                state.RoadDealerAdmins = action?.payload?.data?.data
                    ?.filter((e: any) => e.RoleId === RolesData?.RoadDealerAdmin?.RoleId)
                    .map((item: any) => {
                        return { ...item, FullName: `${item?.First_Name} ${item?.Last_Name}` };
                    });
            })
            .addCase(getAllUsersByDealerID.pending, (state: InitialState) => {
                state.userLoader = { loading: true };
            })
            .addCase(getAllUsersByDealerID.rejected, (state: InitialState) => {
                state.userLoader = { loading: false };
            })
            .addCase(getAllUsersByDealerID.fulfilled, (state: InitialState, action: PayloadAction<any>) => {
                state.userLoader = { loading: false };
                state.dealerUsers = action?.payload?.data?.data;
            })
            .addCase(GetBidByUserIdData.pending, (state: InitialState) => {
                state.myBidsloaderState = { loading: false };
            })
            .addCase(GetBidByUserIdData.rejected, (state: InitialState) => {
                state.myBidsloaderState = { loading: false };
            })
            .addCase(GetBidByUserIdData.fulfilled, (state: InitialState, action: PayloadAction<any>) => {
                state.myBidsloaderState = { loading: false };
                state.mybids = action?.payload?.data;
            })
            .addCase(GetDashboardData.pending, (state: InitialState) => {
                state.dashBoardloaderState = { loading: true };
            })
            .addCase(GetDashboardData.rejected, (state: InitialState) => {
                state.dashBoardloaderState = { loading: false };
            })
            .addCase(GetDashboardData.fulfilled, (state: InitialState, action: PayloadAction<any>) => {
                state.dashBoardloaderState = { loading: false };
                state.dashboardData = action?.payload?.data;
            })
            .addCase(GetViewList.pending, (state: InitialState) => {
                state.userLoader = { loading: true };
            })
            .addCase(GetViewList.rejected, (state: InitialState) => {
                state.userLoader = { loading: false };
            })
            .addCase(GetViewList.fulfilled, (state: InitialState, action: PayloadAction<any>) => {
                state.userLoader = { loading: false };
                state.viewProduct = action?.payload?.data.ProductView ?? [];
            })
            .addCase(ProdcutFilter.pending, (state: InitialState) => {
                state.productFilterLoader = { loading: true };
            })
            .addCase(ProdcutFilter.rejected, (state: InitialState) => {
                state.productFilterLoader = { loading: false };
            })
            .addCase(ProdcutFilter.fulfilled, (state: InitialState) => {
                state.productFilterLoader = { loading: false };
            })
            .addCase(GetRoleDetailsByRoleId.pending, (state: InitialState) => {
                state.rolesLoader = { loading: true };
            })
            .addCase(GetRoleDetailsByRoleId.rejected, (state: InitialState) => {
                state.rolesLoader = { loading: false };
            })
            .addCase(GetRoleDetailsByRoleId.fulfilled, (state: InitialState, action: PayloadAction<any>) => {
                state.rolesLoader = { loading: false };
                state.RoleManagementData = action.payload.data;
            });
    }
});

export const {
    updateUser,
    updateBidsDetails,
    updateLoader,
    handleUpdateDealer,
    showDealersTab,
    showAlert,
    handleModel,
    handleBreakPoints,
    getDealerByID,
    handleErrorState,
    handleTabs,
    handleDealers,
    handleChatOpen,
    handleChatReply,
    updateInventory,
    updateInventoryList,
    handleUpdateInventory,
    handleFiltersInventory,
    handleClearAllInventory,
    handleUpdateDealerUsers,
    handleDealerState,
    handleRoadDealerAdmin,
    handleUpdateRoadDealerAdmin,
    handleProductImges,
    handleProductDetail,
    handleHomePageNavigation,
    handleDealerAdmin,
    handleChatRoomData
} = MainProvider.actions;

export default MainProvider.reducer;
